import { ChefHat } from "lucide-react";

export function PageLoader() {
  return (
    <div
      className="page-loader relative min-h-screen flex items-center justify-center overflow-hidden bg-background"
      role="status"
      aria-live="polite"
      aria-label="Loading page"
    >
      <div className="page-loader__mesh" aria-hidden />
      <div className="page-loader__orb page-loader__orb--1" aria-hidden />
      <div className="page-loader__orb page-loader__orb--2" aria-hidden />
      <div className="page-loader__orb page-loader__orb--3" aria-hidden />
      <div className="page-loader__shimmer" aria-hidden />

      <div className="relative z-10 flex flex-col items-center gap-5 px-6">
        <div className="page-loader__logo-wrap">
          <span className="page-loader__ring" aria-hidden />
          <span className="page-loader__ring page-loader__ring--delayed" aria-hidden />
          <div className="page-loader__logo">
            <ChefHat className="w-9 h-9 text-primary-foreground" />
          </div>
        </div>

        <div className="text-center space-y-1.5">
          <p className="font-display text-lg font-bold tracking-tight text-foreground">
            Butt Karahi POS
          </p>
          <p className="text-sm text-muted-foreground">Loading your workspace</p>
        </div>

        <div className="page-loader__dots" aria-hidden>
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
}
